import { useState } from "react";
import { CameraOff } from "lucide-react";
import { cn } from "@/lib/utils";

export const PhotoPlaceholder = ({ className }) => (
  <div className={cn("flex h-full w-full flex-col items-center justify-center gap-3 bg-charcoal px-6 text-center text-zinc-300", className)} data-testid="photo-placeholder">
    <CameraOff className="h-8 w-8" aria-hidden="true" />
    <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-white">Photos coming soon</p>
    <p className="max-w-[16rem] text-xs leading-relaxed text-zinc-400">The dealer hasn't added photos to this advert yet — call for details.</p>
  </div>
);

export const VehicleImage = ({ v, src, alt, className, eager }) => {
  const [failed, setFailed] = useState(false);
  const url = src ?? v.cardImage;
  if (!url || failed) return <PhotoPlaceholder />;
  return (
    <img
      src={url}
      alt={alt ?? `${v.year} ${v.make} ${v.model} ${v.variant || ""}`.trim()}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      width={720}
      height={540}
      onError={() => setFailed(true)}
      className={cn("h-full w-full object-cover object-[50%_60%]", className)}
    />
  );
};
